import axios, { type AxiosInstance, type CreateAxiosDefaults } from 'axios';

export const createHttpClient = (config?: CreateAxiosDefaults): AxiosInstance =>
  axios.create(config);

export const CancelToken = axios.CancelToken;
export const isAxiosError = axios.isAxiosError;
export const isCancel = axios.isCancel;
